import { Avatar, Stack } from "@mui/material";

const CoachAvatar = ({ imgUrl, avHeight, radius, title, headingCss, openImage = () => {} }) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Avatar onClick={openImage} alt="Remy Sharp" src={imgUrl} sx={{ borderRadius: `${radius}`, height: `${avHeight}`, width: `${avHeight}`, cursor: "pointer" }} />
      <h2 className={`text-xl font-semibold leading-6 text-[#475569]  ${headingCss}`}>{title}</h2>
    </Stack>
  );
};

export default CoachAvatar;
